import { useMutation, useQueryClient } from "react-query";
import { lineOfBusinessInfo } from "../types";
import { updateLineOfBusiness } from "../../../../../actions/Utilities/LineOfBusiness";
import { toast } from "../../../../../components/toastNotification";


const useUpdateLineOfBusiness = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (newData: lineOfBusinessInfo) =>
      updateLineOfBusiness(newData),
    {
      onSuccess: (res: any) => {
        if (res === "Duplicate") {
          toast.fire("Saving Failed", "The data already exists!", "error");
        } else {
          queryClient.invalidateQueries(["GetLineOfBusiness"]);
          toast.fire(
            "Success",
            "Line of Business Updated Successfully",
            "success");
        }
      },
      onError: (error) => {
        toast.fire("Saving Failed", "Failed to Update Line of Business!", "error");
      },
    }
  );
  return mutate;
};
export default useUpdateLineOfBusiness;